// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// const firebaseConfig = {
//   apiKey: "YOUR_API_KEY",
//   authDomain: "your-app.firebaseapp.com",
//   projectId: "your-app",
//   storageBucket: "your-app.appspot.com",
//   messagingSenderId: "YOUR_SENDER_ID",
//   appId: "YOUR_APP_ID",
//   measurementId: "YOUR_MEASUREMENT_ID",
// };

const firebaseConfig = {
  apiKey: "AIzaSyBED1HevbFIlKVKtEwpoQOINM8__tR3rS8",
  authDomain: "pranaam365-655c7.firebaseapp.com",
  projectId: "pranaam365-655c7",
  storageBucket: "pranaam365-655c7.appspot.com", // ✅ fixed
  messagingSenderId: "205894028196",
  appId: "1:205894028196:web:1d7243171d0110af290f31",
  measurementId: "G-VMN7JZ6R9Y"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const getFCMToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: "BIGyo3W4t9BWhV6fzlymqgdd2iiSW8sly6JjkFeSS-aiOArlKuGEgqqoQNEpVJyVzj1h_RB6Mdsu97CHWPUXtCg", // from Firebase Console
      });
      return token;
    }
  } catch (error) {
    console.error("Error getting FCM token", error);
  }
  return null;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
